// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3TVdB","validationTips":"StatementDescriptor_validationTips__2cAur"};